import React from "react";
import PropTypes from "prop-types";

function CardPanelHeader({ title, subtitle, bold,customClass, ...props }) {
	return (
		<div className={`panel-card-header ${bold ? "bold" : ""}`}>
			<h3 className={`panel-card-title ${bold ? "bold" : ""}`}>
				{subtitle !== "" && (
					<span className="panel-card-subtitle">{subtitle}</span>
				)}
				{title}
			</h3>
			<div className={customClass}>{props.children}</div>
		</div>
	);
}

export default CardPanelHeader;
CardPanelHeader.propTypes = {
	title: PropTypes.string,
	subtitle: PropTypes.string,
	// inline: PropTypes.bool,
	children: PropTypes.node.isRequired,
};
CardPanelHeader.defaultProps = {
	title: "",
	subtitle: "",
	// inline: false,
};
